export const isEmptyObject = (obj) => Object.keys(obj).length === 0;

export const isEmptyArray = (value) => Array.isArray(value) && value.length === 0;

export const isPrimative = (value) => value !== Object(value);
